import TopTicker from "./components/TopTicker";
import SiteHeader from "./components/SiteHeader";
import HeroBoard from "./components/HeroBoard";
import ArchiveSection from "./components/ArchiveSection";
import SidebarWidgets from "./components/SidebarWidgets";
import TraceSection from "./components/TraceSection";
import PlatformSection from "./components/PlatformSection";
import DiscussionSection from "./components/DiscussionSection";
import NotesSection from "./components/NotesSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <TopTicker />
      <SiteHeader />

      <main className="w-full">
        <HeroBoard />

        <section id="archive" className="w-full px-4 py-10 md:px-6 md:py-14">
          <div className="mx-auto w-full max-w-[1220px]">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_330px]">
              <ArchiveSection />
              <aside>
                <SidebarWidgets />
              </aside>
            </div>
          </div>
        </section>

        <TraceSection />
        <PlatformSection />
        <DiscussionSection />
        <NotesSection />
      </main>

      <SiteFooter />
    </div>
  );
}